"use client";
import { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

export default function AppErrorBoundary(props: { hasError: boolean, children: ReactNode }) {
    const FallBackUI = () => {
        return (
            <>
                <h3>Something went wrong</h3>
            </>
        );
    }
    return (
        <>
            {props.hasError ?
                <ErrorBoundary
                    FallbackComponent={FallBackUI}
                    onReset={(details) => {
                        // Reset the state of your app so the error doesn't happen again
                    }}
                >
                </ErrorBoundary> : props.children}
        </>
    )
}


